import { atom } from 'recoil';
import { getConfigVariable } from '../../fn/Config';

// Get the default api version to use
const DATE_SELECTION_VERSION = getConfigVariable('DATE_SELECTION_VERSION');

export const dateSelectionVersion = atom({
  key: 'dateSelectionVersion',
  default: window?.dateselectionversion ?? DATE_SELECTION_VERSION,
});
